export default {
  title: 'Registro de Errores',
  cleanupOld: 'Limpiar Antiguos',
  refresh: 'Actualizar',
  selected: '{count} seleccionados',
  markResolved: 'Marcar como Resuelto',
  markOpen: 'Marcar como Abierto',
  clear: 'Limpiar',
  filters: {
    startDate: 'Fecha de Inicio',
    endDate: 'Fecha de Fin',
    errorType: 'Tipo de Error',
    status: 'Estado',
    searchPlaceholder: 'Buscar mensaje o usuario'
  },
  headers: {
    type: 'Tipo',
    message: 'Mensaje',
    user: 'Usuario',
    timestamp: 'Fecha y Hora',
    status: 'Estado'
  },
  errorTypes: {
    javascript: 'JavaScript',
    vue: 'Vue',
    promise: 'Promise',
    manual: 'Manual',
    warning: 'Advertencia',
    info: 'Información'
  },
  statusOptions: {
    open: 'Abierto',
    resolved: 'Resuelto'
  },
  anonymous: 'Anónimo',
  unknown: 'Desconocido',
  noData: 'No se encontraron registros de errores',
  details: {
    title: 'Detalles del Error',
    message: 'Mensaje',
    errorName: 'Nombre del Error',
    url: 'URL',
    route: 'Ruta',
    userAgent: 'Agente de Usuario',
    resolvedAt: 'Resuelto el',
    context: 'Contexto',
    stackTrace: 'Traza de Pila'
  },
  cleanup: {
    title: 'Limpiar Errores Antiguos',
    description: 'Esto eliminará permanentemente los registros de errores con más de {days} días de antigüedad.',
    daysToKeep: 'Días a conservar',
    cancel: 'Cancelar',
    delete: 'Eliminar'
  },
  snackbar: {
    loadFailed: 'Error al cargar el registro de errores',
    markedAsResolved: 'Error marcado como resuelto',
    markedAsOpen: 'Error marcado como abierto',
    updateFailed: 'Error al actualizar el estado del error',
    noErrorsSelected: 'No hay errores seleccionados',
    bulkUpdateSuccess: '{count} errores marcados como {status}',
    bulkUpdateFailed: 'Error al actualizar errores en lote',
    cleanupSuccess: 'Se eliminaron {count} registros de errores antiguos',
    cleanupFailed: 'Error al limpiar registros antiguos'
  },
  notAvailable: 'N/D'
}
